module.exports = __webpack_public_path__ + "static/LogoMobile-2d568503b15ce7edb5829c6246dd6996.png";